import {
  BackButton,
  Button,
  InputText,
  SecondaryButton,
} from "../../components";
import { useForm } from "react-hook-form";
import { searchPlans, setUserSearchInfo } from "../../store/user/actions";
import { connect, useDispatch } from "react-redux";
import { RootState } from "../../store/root-reducer";
import { isScopeLoading } from "../../store/scope-loading/helpers";
import { UserScope } from "../../store/user/types";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import RouteNames from "../../routes/type";

function SearchByWarrantyNumber({ loading }) {
  const disptach = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { control, handleSubmit } = useForm({
    defaultValues: {
      number: "",
      search_type: "search_plan_4",
    },
  });
  const onSubmit = (values) => {
    const body = {
      search_type: values.search_type,
      number: values.number,
    };
    disptach(
      setUserSearchInfo({
        search_type: values.search_type,
        number: body.number,
      })
    );
    disptach(searchPlans(body));
  };

  return (
    <div className=" px-4">
      <div className="mb-8 mt-6">
        <BackButton />
      </div>
      <div className="mb-8">
        <h3 className="text-2xl font-semibold">
          {t("Please enter your warranty number")}
        </h3>
      </div>
      <div className="mb-8">
        <InputText
          name="number"
          placeholder={t("Ex. ( W-E34-WS4566. . . )")}
          label="Warranty number"
          control={control}
          required
          inputProps={{
            autoFocus: true,
          }}
        />
      </div>

      <Button onClick={handleSubmit(onSubmit)} isLoading={loading}>
        {t("Submit")}
      </Button>
      <SecondaryButton
        onClick={() => navigate(`/${RouteNames.SEARCH_BY_PERSONAL_INFO}`)}
        className="mt-3 text-gray-600 bg-gray-100"
      >
        {t("Try Personal Information")}
      </SecondaryButton>
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  loading: isScopeLoading(state.scopeLoading, UserScope),
});

export default connect(mapStateToProps)(SearchByWarrantyNumber);
